import React, { useId } from "react";
import PropTypes from "prop-types";

import { useThemeA } from "../../internal/ThemeAContext";

const DENSITY_CLASSES = {
  comfortable: "akv:p-6 akv:max-[48rem]:p-4",
  compact: "akv:p-4 akv:max-[48rem]:p-3",
};

export function Surface({ action = null, children, description = null, title = null }) {
  const { density } = useThemeA("Surface");
  const generatedId = useId();
  const titleId = title ? `ak-v2-surface-${generatedId.replace(/:/g, "")}` : undefined;
  const Element = title ? "section" : "div";

  return (
    <Element
      className={`akv:box-border akv:min-w-0 akv:rounded-ak-surface akv:border-0 akv:bg-ak-surface akv:shadow-ak-raised ${DENSITY_CLASSES[density]}`}
      aria-labelledby={titleId}
    >
      {(title || description || action) && (
        <header className="akv:mb-4 akv:flex akv:flex-wrap akv:min-w-0 akv:items-start akv:justify-between akv:gap-4">
          {(title || description) && <div className="akv:min-w-0 akv:flex-[1_1_12rem]">
            {title && (
              <h2 className="akv-card-title akv:m-0 akv:font-ak-body akv:text-xl akv:font-bold akv:leading-tight akv:text-ak-text" id={titleId}>
                {title}
              </h2>
            )}
            {description && (
              <p className="akv:mb-0 akv:mt-1 akv:font-ak-body akv:text-sm akv:leading-6 akv:text-ak-muted">
                {description}
              </p>
            )}
          </div>}
          {action && <div className="akv:ml-auto akv:min-w-0 akv:max-w-full akv:flex-[0_1_auto]">{action}</div>}
        </header>
      )}
      <div className="akv:min-w-0">{children}</div>
    </Element>
  );
}

Surface.propTypes = {
  action: PropTypes.node,
  children: PropTypes.node.isRequired,
  description: PropTypes.string,
  title: PropTypes.string,
};
